const itemReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default itemReducer;